import { FC } from 'react'
import { noop } from 'lodash/fp'
import { Loader2 } from 'lucide-react'

import { Button, ButtonProps } from './button'

export type ButtonLoaderProps = ButtonProps & {
  isLoading?: boolean
  className?: string
  loaderColor?: string
}

export const ButtonLoader: FC<ButtonLoaderProps> = ({
  children,
  isLoading,
  loaderColor,
  onClick,
  ...props
}) => (
  <Button
    {...props}
    disabled={isLoading || props.disabled}
    onClick={props.disabled ? noop : onClick}
  >
    {isLoading ? (
      <Loader2 className="size-6 animate-spin" size="48" color={loaderColor} />
    ) : (
      children
    )}
  </Button>
)
